//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PatientClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetPatientPatientQueryParameters = {
  id: string;
};

export type GetPatientByStudyAndUniqIdPatientQueryParameters = {
  studyId?: number | null;
  uniqueId?: string | null;
};

export type GetPatientUniqueIdsPatientQueryParameters = {
  studyId?: number | null;
};

export type GetPatientTagsPatientQueryParameters = {
  studyId?: number | null;
};

export type GetPatientsPatientQueryParameters = {
  searchQuery?: string | null | null;
  patientGroup?: number | null | null;
  isClinic?: boolean | null | null;
  isControlled?: boolean | null | null;
  needChecking?: boolean | null | null;
  hasNoApp?: boolean | null | null;
  withActiveStepName?: string | null | null;
  withClosedStepName?: string | null | null;
  tags?: { [key: string]: string[]; } | null | null;
  studyState?: Types.PatientStudyStateEnum | null | null;
  studyId?: number | null;
  studyStartNotDefine?: boolean | null | null;
  canBeArchived?: boolean | null | null;
  monitoringReviewStatus?: Types.MonitoringReviewStatusEnum | null | null;
  offset?: number | null | null;
  limit?: number | null | null;
  sortBy?: string | null | null;
  sortOrder?: Types.SortOrder | null;
};

export type IsFinishStudyAllowedPatientQueryParameters = {
  id: string;
};

export type GetPatientStudyCountersPatientQueryParameters = {
  studyId: number;
};

export type GetPatientChangesInfoPatientQueryParameters = {
  id?: string | null;
};

export type GetPatientDeviceBindingsPatientQueryParameters = {
  id: string;
};

    
export function getPatientUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/patients/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientDefaultOptions: UseQueryOptions<Types.PatientListDto, unknown, Types.PatientListDto> = {
  queryFn: __getPatient,
};
export function getGetPatientDefaultOptions(): UseQueryOptions<Types.PatientListDto, unknown, Types.PatientListDto> {
  return getPatientDefaultOptions;
};
export function setGetPatientDefaultOptions(options: UseQueryOptions<Types.PatientListDto, unknown, Types.PatientListDto>) {
  getPatientDefaultOptions = options;
}

export function getPatientQueryKey(id: string): QueryKey;
export function getPatientQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetPatientPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'getPatient',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'getPatient',
        ...params
      ]);
  }
}
function __getPatient(context: QueryFunctionContext) {
  return Client.getPatient(
      context.queryKey[2] as string    );
}

export function useGetPatientQuery<TSelectData = Types.PatientListDto, TError = unknown>(dto: GetPatientPatientQueryParameters, options?: UseQueryOptions<Types.PatientListDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a patient by id.
 * @param id The patient id.
 */
export function useGetPatientQuery<TSelectData = Types.PatientListDto, TError = unknown>(id: string, options?: UseQueryOptions<Types.PatientListDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientQuery<TSelectData = Types.PatientListDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientListDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetPatientPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PatientListDto, TError, TSelectData>({
    queryFn: __getPatient,
    queryKey: getPatientQueryKey(id),
    ...getPatientDefaultOptions as unknown as UseQueryOptions<Types.PatientListDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Gets a patient by id.
 * @param id The patient id.
 */
export function setGetPatientData(queryClient: QueryClient, updater: (data: Types.PatientListDto | undefined) => Types.PatientListDto, id: string) {
  queryClient.setQueryData(getPatientQueryKey(id),
    updater
  );
}

/**
 * Gets a patient by id.
 * @param id The patient id.
 */
export function setGetPatientDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientListDto | undefined) => Types.PatientListDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getPatientByStudyAndUniqIdUrl(studyId?: number | undefined, uniqueId?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/patients/byUniqId?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
if (uniqueId === null)
    throw new Error("The parameter 'uniqueId' cannot be null.");
else if (uniqueId !== undefined)
    url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientByStudyAndUniqIdDefaultOptions: UseQueryOptions<Types.PatientListDto, unknown, Types.PatientListDto> = {
  queryFn: __getPatientByStudyAndUniqId,
};
export function getGetPatientByStudyAndUniqIdDefaultOptions(): UseQueryOptions<Types.PatientListDto, unknown, Types.PatientListDto> {
  return getPatientByStudyAndUniqIdDefaultOptions;
};
export function setGetPatientByStudyAndUniqIdDefaultOptions(options: UseQueryOptions<Types.PatientListDto, unknown, Types.PatientListDto>) {
  getPatientByStudyAndUniqIdDefaultOptions = options;
}

export function getPatientByStudyAndUniqIdQueryKey(dto: GetPatientByStudyAndUniqIdPatientQueryParameters): QueryKey;
export function getPatientByStudyAndUniqIdQueryKey(studyId?: number | undefined, uniqueId?: string | undefined): QueryKey;
export function getPatientByStudyAndUniqIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, uniqueId,  } = params[0] as GetPatientByStudyAndUniqIdPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'getPatientByStudyAndUniqId',
        studyId as any,
        uniqueId as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'getPatientByStudyAndUniqId',
        ...params
      ]);
  }
}
function __getPatientByStudyAndUniqId(context: QueryFunctionContext) {
  return Client.getPatientByStudyAndUniqId(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as string | undefined    );
}

export function useGetPatientByStudyAndUniqIdQuery<TSelectData = Types.PatientListDto, TError = unknown>(dto: GetPatientByStudyAndUniqIdPatientQueryParameters, options?: UseQueryOptions<Types.PatientListDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a patient by study id and unique id.
 * @param studyId (optional) Study id
 * @param uniqueId (optional) Patient's unique id
 */
export function useGetPatientByStudyAndUniqIdQuery<TSelectData = Types.PatientListDto, TError = unknown>(studyId?: number | undefined, uniqueId?: string | undefined, options?: UseQueryOptions<Types.PatientListDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientByStudyAndUniqIdQuery<TSelectData = Types.PatientListDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientListDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let uniqueId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, uniqueId,  } = params[0] as GetPatientByStudyAndUniqIdPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, uniqueId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PatientListDto, TError, TSelectData>({
    queryFn: __getPatientByStudyAndUniqId,
    queryKey: getPatientByStudyAndUniqIdQueryKey(studyId, uniqueId),
    ...getPatientByStudyAndUniqIdDefaultOptions as unknown as UseQueryOptions<Types.PatientListDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Gets a patient by study id and unique id.
 * @param studyId (optional) Study id
 * @param uniqueId (optional) Patient's unique id
 */
export function setGetPatientByStudyAndUniqIdData(queryClient: QueryClient, updater: (data: Types.PatientListDto | undefined) => Types.PatientListDto, studyId?: number | undefined, uniqueId?: string | undefined) {
  queryClient.setQueryData(getPatientByStudyAndUniqIdQueryKey(studyId, uniqueId),
    updater
  );
}

/**
 * Gets a patient by study id and unique id.
 * @param studyId (optional) Study id
 * @param uniqueId (optional) Patient's unique id
 */
export function setGetPatientByStudyAndUniqIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientListDto | undefined) => Types.PatientListDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getPatientUniqueIdsUrl(studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/patients/uniqueIds?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientUniqueIdsDefaultOptions: UseQueryOptions<string[], unknown, string[]> = {
  queryFn: __getPatientUniqueIds,
};
export function getGetPatientUniqueIdsDefaultOptions(): UseQueryOptions<string[], unknown, string[]> {
  return getPatientUniqueIdsDefaultOptions;
};
export function setGetPatientUniqueIdsDefaultOptions(options: UseQueryOptions<string[], unknown, string[]>) {
  getPatientUniqueIdsDefaultOptions = options;
}

export function getPatientUniqueIdsQueryKey(studyId?: number | undefined): QueryKey;
export function getPatientUniqueIdsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetPatientUniqueIdsPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'getPatientUniqueIds',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'getPatientUniqueIds',
        ...params
      ]);
  }
}
function __getPatientUniqueIds(context: QueryFunctionContext) {
  return Client.getPatientUniqueIds(
      context.queryKey[2] as number | undefined    );
}

export function useGetPatientUniqueIdsQuery<TSelectData = string[], TError = unknown>(dto: GetPatientUniqueIdsPatientQueryParameters, options?: UseQueryOptions<string[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get unique ids of patients in study
 * @param studyId (optional) The id of the study
 */
export function useGetPatientUniqueIdsQuery<TSelectData = string[], TError = unknown>(studyId?: number | undefined, options?: UseQueryOptions<string[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientUniqueIdsQuery<TSelectData = string[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetPatientUniqueIdsPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<string[], TError, TSelectData>({
    queryFn: __getPatientUniqueIds,
    queryKey: getPatientUniqueIdsQueryKey(studyId),
    ...getPatientUniqueIdsDefaultOptions as unknown as UseQueryOptions<string[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get unique ids of patients in study
 * @param studyId (optional) The id of the study
 */
export function setGetPatientUniqueIdsData(queryClient: QueryClient, updater: (data: string[] | undefined) => string[], studyId?: number | undefined) {
  queryClient.setQueryData(getPatientUniqueIdsQueryKey(studyId),
    updater
  );
}

/**
 * Get unique ids of patients in study
 * @param studyId (optional) The id of the study
 */
export function setGetPatientUniqueIdsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string[] | undefined) => string[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getPatientTagsUrl(studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/patients/tags?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientTagsDefaultOptions: UseQueryOptions<{ [key: string]: string[]; }, unknown, { [key: string]: string[]; }> = {
  queryFn: __getPatientTags,
};
export function getGetPatientTagsDefaultOptions(): UseQueryOptions<{ [key: string]: string[]; }, unknown, { [key: string]: string[]; }> {
  return getPatientTagsDefaultOptions;
};
export function setGetPatientTagsDefaultOptions(options: UseQueryOptions<{ [key: string]: string[]; }, unknown, { [key: string]: string[]; }>) {
  getPatientTagsDefaultOptions = options;
}

export function getPatientTagsQueryKey(studyId?: number | undefined): QueryKey;
export function getPatientTagsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetPatientTagsPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'getPatientTags',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'getPatientTags',
        ...params
      ]);
  }
}
function __getPatientTags(context: QueryFunctionContext) {
  return Client.getPatientTags(
      context.queryKey[2] as number | undefined    );
}

export function useGetPatientTagsQuery<TSelectData = { [key: string]: string[]; }, TError = unknown>(dto: GetPatientTagsPatientQueryParameters, options?: UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get all tags of patients in the study.
If the user is a staff of the study,
then only tags that are assigned to him will be returned.
 * @param studyId (optional) Id of the study
 */
export function useGetPatientTagsQuery<TSelectData = { [key: string]: string[]; }, TError = unknown>(studyId?: number | undefined, options?: UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientTagsQuery<TSelectData = { [key: string]: string[]; }, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetPatientTagsPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<{ [key: string]: string[]; }, TError, TSelectData>({
    queryFn: __getPatientTags,
    queryKey: getPatientTagsQueryKey(studyId),
    ...getPatientTagsDefaultOptions as unknown as UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData>,
    ...options,
  });
}
/**
 * Get all tags of patients in the study.
If the user is a staff of the study,
then only tags that are assigned to him will be returned.
 * @param studyId (optional) Id of the study
 */
export function setGetPatientTagsData(queryClient: QueryClient, updater: (data: { [key: string]: string[]; } | undefined) => { [key: string]: string[]; }, studyId?: number | undefined) {
  queryClient.setQueryData(getPatientTagsQueryKey(studyId),
    updater
  );
}

/**
 * Get all tags of patients in the study.
If the user is a staff of the study,
then only tags that are assigned to him will be returned.
 * @param studyId (optional) Id of the study
 */
export function setGetPatientTagsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: { [key: string]: string[]; } | undefined) => { [key: string]: string[]; }) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getPatientsUrl(searchQuery?: string | null | undefined, patientGroup?: number | null | undefined, isClinic?: boolean | null | undefined, isControlled?: boolean | null | undefined, needChecking?: boolean | null | undefined, hasNoApp?: boolean | null | undefined, withActiveStepName?: string | null | undefined, withClosedStepName?: string | null | undefined, tags?: { [key: string]: string[]; } | null | undefined, studyState?: Types.PatientStudyStateEnum | null | undefined, studyId?: number | undefined, studyStartNotDefine?: boolean | null | undefined, canBeArchived?: boolean | null | undefined, monitoringReviewStatus?: Types.MonitoringReviewStatusEnum | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/patients?";
if (searchQuery !== undefined && searchQuery !== null)
    url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
if (patientGroup !== undefined && patientGroup !== null)
    url_ += "PatientGroup=" + encodeURIComponent("" + patientGroup) + "&";
if (isClinic !== undefined && isClinic !== null)
    url_ += "IsClinic=" + encodeURIComponent("" + isClinic) + "&";
if (isControlled !== undefined && isControlled !== null)
    url_ += "IsControlled=" + encodeURIComponent("" + isControlled) + "&";
if (needChecking !== undefined && needChecking !== null)
    url_ += "NeedChecking=" + encodeURIComponent("" + needChecking) + "&";
if (hasNoApp !== undefined && hasNoApp !== null)
    url_ += "HasNoApp=" + encodeURIComponent("" + hasNoApp) + "&";
if (withActiveStepName !== undefined && withActiveStepName !== null)
    url_ += "WithActiveStepName=" + encodeURIComponent("" + withActiveStepName) + "&";
if (withClosedStepName !== undefined && withClosedStepName !== null)
    url_ += "WithClosedStepName=" + encodeURIComponent("" + withClosedStepName) + "&";
if (tags !== undefined && tags !== null)
{
    const content_ = JSON.stringify(tags);
    url_ += "Tags=" + encodeURIComponent(content_) + "&";
}
if (studyState !== undefined && studyState !== null)
    url_ += "StudyState=" + encodeURIComponent("" + studyState) + "&";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "StudyId=" + encodeURIComponent("" + studyId) + "&";
if (studyStartNotDefine !== undefined && studyStartNotDefine !== null)
    url_ += "StudyStartNotDefine=" + encodeURIComponent("" + studyStartNotDefine) + "&";
if (canBeArchived !== undefined && canBeArchived !== null)
    url_ += "CanBeArchived=" + encodeURIComponent("" + canBeArchived) + "&";
if (monitoringReviewStatus !== undefined && monitoringReviewStatus !== null)
    url_ += "MonitoringReviewStatus=" + encodeURIComponent("" + monitoringReviewStatus) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientsDefaultOptions: UseQueryOptions<Types.PagedResultOfPatientListDto, unknown, Types.PagedResultOfPatientListDto> = {
  queryFn: __getPatients,
};
export function getGetPatientsDefaultOptions(): UseQueryOptions<Types.PagedResultOfPatientListDto, unknown, Types.PagedResultOfPatientListDto> {
  return getPatientsDefaultOptions;
};
export function setGetPatientsDefaultOptions(options: UseQueryOptions<Types.PagedResultOfPatientListDto, unknown, Types.PagedResultOfPatientListDto>) {
  getPatientsDefaultOptions = options;
}

export function getPatientsQueryKey(dto: GetPatientsPatientQueryParameters): QueryKey;
export function getPatientsQueryKey(searchQuery?: string | null | undefined, patientGroup?: number | null | undefined, isClinic?: boolean | null | undefined, isControlled?: boolean | null | undefined, needChecking?: boolean | null | undefined, hasNoApp?: boolean | null | undefined, withActiveStepName?: string | null | undefined, withClosedStepName?: string | null | undefined, tags?: { [key: string]: string[]; } | null | undefined, studyState?: Types.PatientStudyStateEnum | null | undefined, studyId?: number | undefined, studyStartNotDefine?: boolean | null | undefined, canBeArchived?: boolean | null | undefined, monitoringReviewStatus?: Types.MonitoringReviewStatusEnum | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getPatientsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { searchQuery, patientGroup, isClinic, isControlled, needChecking, hasNoApp, withActiveStepName, withClosedStepName, tags, studyState, studyId, studyStartNotDefine, canBeArchived, monitoringReviewStatus, offset, limit, sortBy, sortOrder,  } = params[0] as GetPatientsPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'getPatients',
        searchQuery as any,
        patientGroup as any,
        isClinic as any,
        isControlled as any,
        needChecking as any,
        hasNoApp as any,
        withActiveStepName as any,
        withClosedStepName as any,
        tags as any,
        studyState as any,
        studyId as any,
        studyStartNotDefine as any,
        canBeArchived as any,
        monitoringReviewStatus as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'getPatients',
        ...params
      ]);
  }
}
function __getPatients(context: QueryFunctionContext) {
  return Client.getPatients(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as boolean | null | undefined,       context.queryKey[5] as boolean | null | undefined,       context.queryKey[6] as boolean | null | undefined,       context.queryKey[7] as boolean | null | undefined,       context.queryKey[8] as string | null | undefined,       context.queryKey[9] as string | null | undefined,       context.queryKey[10] as { [key: string]: string[]; } | null | undefined,       context.queryKey[11] as Types.PatientStudyStateEnum | null | undefined,       context.queryKey[12] as number | undefined,       context.queryKey[13] as boolean | null | undefined,       context.queryKey[14] as boolean | null | undefined,       context.queryKey[15] as Types.MonitoringReviewStatusEnum | null | undefined,       context.queryKey[16] as number | null | undefined,       context.queryKey[17] as number | null | undefined,       context.queryKey[18] as string | null | undefined,       context.queryKey[19] as Types.SortOrder | undefined    );
}

export function useGetPatientsQuery<TSelectData = Types.PagedResultOfPatientListDto, TError = unknown>(dto: GetPatientsPatientQueryParameters, options?: UseQueryOptions<Types.PagedResultOfPatientListDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all patients.
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all patient which name or last name contains "Mike".
 * @param patientGroup (optional) Patient's group for paged request.
 * @param isClinic (optional) Filter patient by "clinic" status
 * @param isControlled (optional) Filter patient by "Controlled" status
 * @param needChecking (optional) Filter patient by "need check the patient" status
 * @param hasNoApp (optional) Filter patient by "No app" status
 * @param withActiveStepName (optional) Filter patient by "Route progress" step with active state
Active state is true when the RouteProgressStateEnum is InProgress or InProgressManually
 * @param withClosedStepName (optional) Filter patient by "Route progress" step with closed state
Closed state is true when the RouteProgressStateEnum is Done or Missed or Approved
 * @param tags (optional) Tags that will be used to filter patients
 * @param studyState (optional) Filter patient by "study state" status
 * @param studyId (optional) Id of study for paged request.
 * @param studyStartNotDefine (optional) Filter patient by "Study start not define" status
 * @param canBeArchived (optional) Filter patient by ready to be archived
 * @param monitoringReviewStatus (optional) Filter patient by "Monitoring review status"
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetPatientsQuery<TSelectData = Types.PagedResultOfPatientListDto, TError = unknown>(searchQuery?: string | null | undefined, patientGroup?: number | null | undefined, isClinic?: boolean | null | undefined, isControlled?: boolean | null | undefined, needChecking?: boolean | null | undefined, hasNoApp?: boolean | null | undefined, withActiveStepName?: string | null | undefined, withClosedStepName?: string | null | undefined, tags?: { [key: string]: string[]; } | null | undefined, studyState?: Types.PatientStudyStateEnum | null | undefined, studyId?: number | undefined, studyStartNotDefine?: boolean | null | undefined, canBeArchived?: boolean | null | undefined, monitoringReviewStatus?: Types.MonitoringReviewStatusEnum | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: UseQueryOptions<Types.PagedResultOfPatientListDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientsQuery<TSelectData = Types.PagedResultOfPatientListDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfPatientListDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let searchQuery: any = undefined;
  let patientGroup: any = undefined;
  let isClinic: any = undefined;
  let isControlled: any = undefined;
  let needChecking: any = undefined;
  let hasNoApp: any = undefined;
  let withActiveStepName: any = undefined;
  let withClosedStepName: any = undefined;
  let tags: any = undefined;
  let studyState: any = undefined;
  let studyId: any = undefined;
  let studyStartNotDefine: any = undefined;
  let canBeArchived: any = undefined;
  let monitoringReviewStatus: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ searchQuery, patientGroup, isClinic, isControlled, needChecking, hasNoApp, withActiveStepName, withClosedStepName, tags, studyState, studyId, studyStartNotDefine, canBeArchived, monitoringReviewStatus, offset, limit, sortBy, sortOrder,  } = params[0] as GetPatientsPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [searchQuery, patientGroup, isClinic, isControlled, needChecking, hasNoApp, withActiveStepName, withClosedStepName, tags, studyState, studyId, studyStartNotDefine, canBeArchived, monitoringReviewStatus, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PagedResultOfPatientListDto, TError, TSelectData>({
    queryFn: __getPatients,
    queryKey: getPatientsQueryKey(searchQuery, patientGroup, isClinic, isControlled, needChecking, hasNoApp, withActiveStepName, withClosedStepName, tags, studyState, studyId, studyStartNotDefine, canBeArchived, monitoringReviewStatus, offset, limit, sortBy, sortOrder),
    ...getPatientsDefaultOptions as unknown as UseQueryOptions<Types.PagedResultOfPatientListDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Gets all patients.
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all patient which name or last name contains "Mike".
 * @param patientGroup (optional) Patient's group for paged request.
 * @param isClinic (optional) Filter patient by "clinic" status
 * @param isControlled (optional) Filter patient by "Controlled" status
 * @param needChecking (optional) Filter patient by "need check the patient" status
 * @param hasNoApp (optional) Filter patient by "No app" status
 * @param withActiveStepName (optional) Filter patient by "Route progress" step with active state
Active state is true when the RouteProgressStateEnum is InProgress or InProgressManually
 * @param withClosedStepName (optional) Filter patient by "Route progress" step with closed state
Closed state is true when the RouteProgressStateEnum is Done or Missed or Approved
 * @param tags (optional) Tags that will be used to filter patients
 * @param studyState (optional) Filter patient by "study state" status
 * @param studyId (optional) Id of study for paged request.
 * @param studyStartNotDefine (optional) Filter patient by "Study start not define" status
 * @param canBeArchived (optional) Filter patient by ready to be archived
 * @param monitoringReviewStatus (optional) Filter patient by "Monitoring review status"
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetPatientsData(queryClient: QueryClient, updater: (data: Types.PagedResultOfPatientListDto | undefined) => Types.PagedResultOfPatientListDto, searchQuery?: string | null | undefined, patientGroup?: number | null | undefined, isClinic?: boolean | null | undefined, isControlled?: boolean | null | undefined, needChecking?: boolean | null | undefined, hasNoApp?: boolean | null | undefined, withActiveStepName?: string | null | undefined, withClosedStepName?: string | null | undefined, tags?: { [key: string]: string[]; } | null | undefined, studyState?: Types.PatientStudyStateEnum | null | undefined, studyId?: number | undefined, studyStartNotDefine?: boolean | null | undefined, canBeArchived?: boolean | null | undefined, monitoringReviewStatus?: Types.MonitoringReviewStatusEnum | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getPatientsQueryKey(searchQuery, patientGroup, isClinic, isControlled, needChecking, hasNoApp, withActiveStepName, withClosedStepName, tags, studyState, studyId, studyStartNotDefine, canBeArchived, monitoringReviewStatus, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets all patients.
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all patient which name or last name contains "Mike".
 * @param patientGroup (optional) Patient's group for paged request.
 * @param isClinic (optional) Filter patient by "clinic" status
 * @param isControlled (optional) Filter patient by "Controlled" status
 * @param needChecking (optional) Filter patient by "need check the patient" status
 * @param hasNoApp (optional) Filter patient by "No app" status
 * @param withActiveStepName (optional) Filter patient by "Route progress" step with active state
Active state is true when the RouteProgressStateEnum is InProgress or InProgressManually
 * @param withClosedStepName (optional) Filter patient by "Route progress" step with closed state
Closed state is true when the RouteProgressStateEnum is Done or Missed or Approved
 * @param tags (optional) Tags that will be used to filter patients
 * @param studyState (optional) Filter patient by "study state" status
 * @param studyId (optional) Id of study for paged request.
 * @param studyStartNotDefine (optional) Filter patient by "Study start not define" status
 * @param canBeArchived (optional) Filter patient by ready to be archived
 * @param monitoringReviewStatus (optional) Filter patient by "Monitoring review status"
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetPatientsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfPatientListDto | undefined) => Types.PagedResultOfPatientListDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function generatePatientAccessCodeUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/code";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function generatePatientAccessCodeMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'generatePatientAccessCode',
      id as any,
    ]);
}

/**
 * Generates authorization code for Patient. It needs to be able to access to the app.
 */
export function useGeneratePatientAccessCodeMutation<TContext>(id: string, options?: Omit<UseMutationOptions<string, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, void, TContext> {
  const key = generatePatientAccessCodeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.generatePatientAccessCode(id), {...options, mutationKey: key});
}
  
    
export function applyFilterToPatientUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/filter";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function applyFilterToPatientMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'applyFilterToPatient',
      id as any,
    ]);
}

/**
 * Applies new filter values for new patient.
 * @param id Id of the patient
 * @param dto Filter values DTO.
 */
export function useApplyFilterToPatientMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.PatientDto, unknown, Types.UpdatePatientFilterDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PatientDto, unknown, Types.UpdatePatientFilterDto, TContext> {
  const key = applyFilterToPatientMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.UpdatePatientFilterDto) => Client.applyFilterToPatient(id, dto), {...options, mutationKey: key});
}
  
    
export function updatePatientTagsUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/tags";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updatePatientTagsMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'updatePatientTags',
      id as any,
    ]);
}

/**
 * Update tags of the patient
 * @param id Id of the patient
 * @param tags New tags
 */
export function useUpdatePatientTagsMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.PatientDto, unknown, { [key: string]: string; }, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PatientDto, unknown, { [key: string]: string; }, TContext> {
  const key = updatePatientTagsMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((tags: { [key: string]: string; }) => Client.updatePatientTags(id, tags), {...options, mutationKey: key});
}
  
    
export function finishStudyForPatientUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/finishStudy";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function finishStudyForPatientMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'finishStudyForPatient',
      id as any,
    ]);
}

/**
 * Finish study for patient in non-eCRF study.
 * @param id Id of the patient
 * @param dto Finish study DTO.
 */
export function useFinishStudyForPatientMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, Types.FinishPatientStudyDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.FinishPatientStudyDto, TContext> {
  const key = finishStudyForPatientMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.FinishPatientStudyDto) => Client.finishStudyForPatient(id, dto), {...options, mutationKey: key});
}
  
    
export function archivePatientUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/archive";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function archivePatientMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'archivePatient',
      id as any,
    ]);
}

/**
 * Archive the patient
 * @param id Id of the patient
 */
export function useArchivePatientMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = archivePatientMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.archivePatient(id), {...options, mutationKey: key});
}
  
    
export function isFinishStudyAllowedUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/isFinishStudyAllowed";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let isFinishStudyAllowedDefaultOptions: UseQueryOptions<boolean, unknown, boolean> = {
  queryFn: __isFinishStudyAllowed,
};
export function getIsFinishStudyAllowedDefaultOptions(): UseQueryOptions<boolean, unknown, boolean> {
  return isFinishStudyAllowedDefaultOptions;
};
export function setIsFinishStudyAllowedDefaultOptions(options: UseQueryOptions<boolean, unknown, boolean>) {
  isFinishStudyAllowedDefaultOptions = options;
}

export function isFinishStudyAllowedQueryKey(id: string): QueryKey;
export function isFinishStudyAllowedQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as IsFinishStudyAllowedPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'isFinishStudyAllowed',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'isFinishStudyAllowed',
        ...params
      ]);
  }
}
function __isFinishStudyAllowed(context: QueryFunctionContext) {
  return Client.isFinishStudyAllowed(
      context.queryKey[2] as string    );
}

export function useIsFinishStudyAllowedQuery<TSelectData = boolean, TError = unknown>(dto: IsFinishStudyAllowedPatientQueryParameters, options?: UseQueryOptions<boolean, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Check is finish study allowed for patient.
 * @param id Id of the patient
 */
export function useIsFinishStudyAllowedQuery<TSelectData = boolean, TError = unknown>(id: string, options?: UseQueryOptions<boolean, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useIsFinishStudyAllowedQuery<TSelectData = boolean, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<boolean, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as IsFinishStudyAllowedPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<boolean, TError, TSelectData>({
    queryFn: __isFinishStudyAllowed,
    queryKey: isFinishStudyAllowedQueryKey(id),
    ...isFinishStudyAllowedDefaultOptions as unknown as UseQueryOptions<boolean, TError, TSelectData>,
    ...options,
  });
}
/**
 * Check is finish study allowed for patient.
 * @param id Id of the patient
 */
export function setIsFinishStudyAllowedData(queryClient: QueryClient, updater: (data: boolean | undefined) => boolean, id: string) {
  queryClient.setQueryData(isFinishStudyAllowedQueryKey(id),
    updater
  );
}

/**
 * Check is finish study allowed for patient.
 * @param id Id of the patient
 */
export function setIsFinishStudyAllowedDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: boolean | undefined) => boolean) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getPatientStudyCountersUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/patients/{studyId}/counters";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientStudyCountersDefaultOptions: UseQueryOptions<Types.PatientGroupCountersDto[], unknown, Types.PatientGroupCountersDto[]> = {
  queryFn: __getPatientStudyCounters,
};
export function getGetPatientStudyCountersDefaultOptions(): UseQueryOptions<Types.PatientGroupCountersDto[], unknown, Types.PatientGroupCountersDto[]> {
  return getPatientStudyCountersDefaultOptions;
};
export function setGetPatientStudyCountersDefaultOptions(options: UseQueryOptions<Types.PatientGroupCountersDto[], unknown, Types.PatientGroupCountersDto[]>) {
  getPatientStudyCountersDefaultOptions = options;
}

export function getPatientStudyCountersQueryKey(studyId: number): QueryKey;
export function getPatientStudyCountersQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetPatientStudyCountersPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'getPatientStudyCounters',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'getPatientStudyCounters',
        ...params
      ]);
  }
}
function __getPatientStudyCounters(context: QueryFunctionContext) {
  return Client.getPatientStudyCounters(
      context.queryKey[2] as number    );
}

export function useGetPatientStudyCountersQuery<TSelectData = Types.PatientGroupCountersDto[], TError = unknown>(dto: GetPatientStudyCountersPatientQueryParameters, options?: UseQueryOptions<Types.PatientGroupCountersDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetPatientStudyCountersQuery<TSelectData = Types.PatientGroupCountersDto[], TError = unknown>(studyId: number, options?: UseQueryOptions<Types.PatientGroupCountersDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientStudyCountersQuery<TSelectData = Types.PatientGroupCountersDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientGroupCountersDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetPatientStudyCountersPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PatientGroupCountersDto[], TError, TSelectData>({
    queryFn: __getPatientStudyCounters,
    queryKey: getPatientStudyCountersQueryKey(studyId),
    ...getPatientStudyCountersDefaultOptions as unknown as UseQueryOptions<Types.PatientGroupCountersDto[], TError, TSelectData>,
    ...options,
  });
}

export function setGetPatientStudyCountersData(queryClient: QueryClient, updater: (data: Types.PatientGroupCountersDto[] | undefined) => Types.PatientGroupCountersDto[], studyId: number) {
  queryClient.setQueryData(getPatientStudyCountersQueryKey(studyId),
    updater
  );
}

export function setGetPatientStudyCountersDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientGroupCountersDto[] | undefined) => Types.PatientGroupCountersDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getPatientChangesInfoUrl(id?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/patients/changes?";
if (id === null)
    throw new Error("The parameter 'id' cannot be null.");
else if (id !== undefined)
    url_ += "id=" + encodeURIComponent("" + id) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientChangesInfoDefaultOptions: UseQueryOptions<Types.PatientChangesDetails, unknown, Types.PatientChangesDetails> = {
  queryFn: __getPatientChangesInfo,
};
export function getGetPatientChangesInfoDefaultOptions(): UseQueryOptions<Types.PatientChangesDetails, unknown, Types.PatientChangesDetails> {
  return getPatientChangesInfoDefaultOptions;
};
export function setGetPatientChangesInfoDefaultOptions(options: UseQueryOptions<Types.PatientChangesDetails, unknown, Types.PatientChangesDetails>) {
  getPatientChangesInfoDefaultOptions = options;
}

export function getPatientChangesInfoQueryKey(id?: string | undefined): QueryKey;
export function getPatientChangesInfoQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetPatientChangesInfoPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'getPatientChangesInfo',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'getPatientChangesInfo',
        ...params
      ]);
  }
}
function __getPatientChangesInfo(context: QueryFunctionContext) {
  return Client.getPatientChangesInfo(
      context.queryKey[2] as string | undefined    );
}

export function useGetPatientChangesInfoQuery<TSelectData = Types.PatientChangesDetails, TError = unknown>(dto: GetPatientChangesInfoPatientQueryParameters, options?: UseQueryOptions<Types.PatientChangesDetails, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Return information with related reason of update for requested patientId
 * @param id (optional) Patient's Id
 */
export function useGetPatientChangesInfoQuery<TSelectData = Types.PatientChangesDetails, TError = unknown>(id?: string | undefined, options?: UseQueryOptions<Types.PatientChangesDetails, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientChangesInfoQuery<TSelectData = Types.PatientChangesDetails, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientChangesDetails, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetPatientChangesInfoPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PatientChangesDetails, TError, TSelectData>({
    queryFn: __getPatientChangesInfo,
    queryKey: getPatientChangesInfoQueryKey(id),
    ...getPatientChangesInfoDefaultOptions as unknown as UseQueryOptions<Types.PatientChangesDetails, TError, TSelectData>,
    ...options,
  });
}
/**
 * Return information with related reason of update for requested patientId
 * @param id (optional) Patient's Id
 */
export function setGetPatientChangesInfoData(queryClient: QueryClient, updater: (data: Types.PatientChangesDetails | undefined) => Types.PatientChangesDetails, id?: string | undefined) {
  queryClient.setQueryData(getPatientChangesInfoQueryKey(id),
    updater
  );
}

/**
 * Return information with related reason of update for requested patientId
 * @param id (optional) Patient's Id
 */
export function setGetPatientChangesInfoDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientChangesDetails | undefined) => Types.PatientChangesDetails) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getPatientDeviceBindingsUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/deviceBindings";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientDeviceBindingsDefaultOptions: UseQueryOptions<Types.DeviceBindingDto[], unknown, Types.DeviceBindingDto[]> = {
  queryFn: __getPatientDeviceBindings,
};
export function getGetPatientDeviceBindingsDefaultOptions(): UseQueryOptions<Types.DeviceBindingDto[], unknown, Types.DeviceBindingDto[]> {
  return getPatientDeviceBindingsDefaultOptions;
};
export function setGetPatientDeviceBindingsDefaultOptions(options: UseQueryOptions<Types.DeviceBindingDto[], unknown, Types.DeviceBindingDto[]>) {
  getPatientDeviceBindingsDefaultOptions = options;
}

export function getPatientDeviceBindingsQueryKey(id: string): QueryKey;
export function getPatientDeviceBindingsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetPatientDeviceBindingsPatientQueryParameters;

    return trimArrayEnd([
        'PatientClient',
        'getPatientDeviceBindings',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientClient',
        'getPatientDeviceBindings',
        ...params
      ]);
  }
}
function __getPatientDeviceBindings(context: QueryFunctionContext) {
  return Client.getPatientDeviceBindings(
      context.queryKey[2] as string    );
}

export function useGetPatientDeviceBindingsQuery<TSelectData = Types.DeviceBindingDto[], TError = unknown>(dto: GetPatientDeviceBindingsPatientQueryParameters, options?: UseQueryOptions<Types.DeviceBindingDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Return list of devices which are assigned to patient
 * @param id Patient's Id
 */
export function useGetPatientDeviceBindingsQuery<TSelectData = Types.DeviceBindingDto[], TError = unknown>(id: string, options?: UseQueryOptions<Types.DeviceBindingDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientDeviceBindingsQuery<TSelectData = Types.DeviceBindingDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DeviceBindingDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetPatientDeviceBindingsPatientQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.DeviceBindingDto[], TError, TSelectData>({
    queryFn: __getPatientDeviceBindings,
    queryKey: getPatientDeviceBindingsQueryKey(id),
    ...getPatientDeviceBindingsDefaultOptions as unknown as UseQueryOptions<Types.DeviceBindingDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Return list of devices which are assigned to patient
 * @param id Patient's Id
 */
export function setGetPatientDeviceBindingsData(queryClient: QueryClient, updater: (data: Types.DeviceBindingDto[] | undefined) => Types.DeviceBindingDto[], id: string) {
  queryClient.setQueryData(getPatientDeviceBindingsQueryKey(id),
    updater
  );
}

/**
 * Return list of devices which are assigned to patient
 * @param id Patient's Id
 */
export function setGetPatientDeviceBindingsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DeviceBindingDto[] | undefined) => Types.DeviceBindingDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function reviewPatientUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/review";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function reviewPatientMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'reviewPatient',
      id as any,
    ]);
}

/**
 * Review patient by id
 * @param id Id of the patient
 */
export function useReviewPatientMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = reviewPatientMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.reviewPatient(id), {...options, mutationKey: key});
}
  
    
export function revokePatientReviewUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/patients/{id}/revokeReview";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function revokePatientReviewMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'PatientClient',
      'revokePatientReview',
      id as any,
    ]);
}

/**
 * Revoke review for patient by id
 */
export function useRevokePatientReviewMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = revokePatientReviewMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.revokePatientReview(id), {...options, mutationKey: key});
}